export const limitsChoiceItems: { label: string; isIncluded: boolean }[] = [
    { label: 'Да', isIncluded: true },
    { label: 'Нет', isIncluded: false },
];
